import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Collapse, Box, Link, Typography } from '@mui/material';
import { useEffect } from 'react';

function ReadMore({
  children,
  childrenRef,
  minSize = 60,
  starClose = false,
  onChange = () => {},
}) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const [heightChildren, setHeightChildren] = useState(0);

  const handleExpandClick = () => {
    setExpanded((ex) => !ex);
  };

  useEffect(() => {
    if (childrenRef.current) {
      const { clientHeight } = childrenRef.current;
      setHeightChildren(clientHeight);
      if (clientHeight > minSize && !starClose) {
        setExpanded(true);
      }
    }
  }, [childrenRef]);

  useEffect(() => {
    onChange(expanded);
  }, [expanded]);

  return (
    <Box>
      <Box sx={{ mt: 2 }}>
        <Typography sx={{ flex: 1 }} variant="body4" component="div">
          {t('checkout.global.about')}
        </Typography>
      </Box>
      <Collapse
        in={expanded}
        timeout="auto"
        sx={{ marginTop: '16px' }}
        collapsedSize={minSize}
      >
        {children}
      </Collapse>
      <Box>
        <Link
          variant="caption"
          sx={{
            'textDecoration': 'underline',
            '&:hover': {
              cursor: 'pointer',
            },
            'color': (theme) => theme.palette.secondary.main,
          }}
          onClick={handleExpandClick}
        >
          {heightChildren > minSize ? (
            <>
              {' '}
              {`${
                expanded
                  ? t('checkout.global.readLess')
                  : t('checkout.global.readMore')
              }`}
            </>
          ) : null}
        </Link>
      </Box>
    </Box>
  );
}

ReadMore.propTypes = {
  children: PropTypes.object.isRequired,
};

export default ReadMore;
